import {
    setRawMaterialVendors,
    addRawMaterialVendor,
    updateRawMaterialVendor,
    deleteRawMaterialVendor,
    setLoading
} from "./rawMaterialVendorSlice";

import { getMethod, postMethod, putMethod, deleteMethod } from "../../api-service/api-service";

export const fetchAllRawMaterialVendorAction = (page = 1, limit = 10) => async (dispatch) => {
    try {
        dispatch(setLoading(true));

        const response = await getMethod(
            `/raw-material-vendor?page=${page}&limit=${limit}`
        );

        dispatch(setRawMaterialVendors(response));
        dispatch(setLoading(false));

        return response;
    } catch (error) {
        dispatch(setLoading(false));
        return { success: false, message: error };
    }
};

export const createRawMaterialVendorAction = (data) => async (dispatch) => {
    try {
        const response = await postMethod(`/raw-material-vendor`, data);

        if (response?.data) {
            dispatch(addRawMaterialVendor(response.data));
        }

        return response;
    } catch (error) {
        return { success: false, message: error };
    }
};

export const updateRawMaterialVendorAction = (id, data) => async (dispatch) => {
    try {
        const response = await putMethod(`/raw-material-vendor/${id}`, data);

        if (response?.data) {
            dispatch(updateRawMaterialVendor(response.data));
        }

        return response;
    } catch (error) {
        return { success: false, message: error };
    }
};

export const deleteRawMaterialVendorAction = (id) => async (dispatch) => {
    try {
        const response = await deleteMethod(`/raw-material-vendor/${id}`);

        dispatch(deleteRawMaterialVendor(id));

        return response;
    } catch (error) {
        return { success: false, message: error };
    }
};
